import {Component, Input, ViewChild} from '@angular/core';
import {WizardStepComponent} from '../../wizard-step-component.interface';
import {AddressDetailsFormComponent, AddressFormData} from '../../../../../shared/address-details-form/address-details-form.component';

export type AddressStepData = AddressFormData;

@Component({
  selector: 'app-address-step',
  standalone: true,
  imports: [AddressDetailsFormComponent],
  templateUrl: './address-step.component.html',
})
export class AddressStepComponent implements WizardStepComponent {

  @Input() initialData: AddressStepData | null;

  @ViewChild(AddressDetailsFormComponent) private addressForm: AddressDetailsFormComponent;

  isValid(): boolean {
    return this.addressForm.isValid();
  }

  getValue(): AddressStepData {
    return this.addressForm.getFormValue();
  }
}
